import React, { useState } from "react";
import clsx from "clsx";
import { useUpdateData } from "hooks/useApiHooks";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCanvasHandler } from "hooks/useCanvasHandler";

const ChangeOrderStatus = ({ initialData, refetch, onSuccess, onError }) => {
  const API_URL = "/reservation";

  const [formData, setFormData] = useState({
    status: initialData?.status || "",
  });

  const { updateData: updateBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}/status`
  );

  const { handleSuccessToast, handleError } = useCanvasHandler();

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    updateBooking,
    async () => {
      handleSuccessToast(true, "Status updated successfully!");
      await refetch?.();
      onSuccess?.();
    },
    (error) => {
      handleError(true, error || "Failed to update status.");
      onError?.(error);
    }
  );

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;

    console.log("🔍 Status dipilih:", newStatus); // Debugging

    // ✅ Gunakan callback di setFormData agar state selalu up-to-date sebelum submit
    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData, status: newStatus };

      console.log("📤 Data yang dikirim ke API:", updatedFormData); // Debugging

      // ✅ Panggil submit tanpa event (karena dropdown tidak submit form)
      handleSubmit(updatedFormData, { preventDefault: () => {} });

      return updatedFormData; // Perbarui state setelah submit
    });
  };

  return (
    <div className="form-group">
      <label htmlFor="status" className="form-label">Booking Status</label>
      <select
        className={clsx("form-select")}
        id="status"
        name="status"
        value={formData.status}
        onChange={handleStatusChange}
        disabled={isSubmitting}
      >
        <option value="" disabled>Pilih status</option>
        {[
          { value: "booked", label: "Book" },
          { value: "reconfirmed", label: "Re Confirm" },
          { value: "confirmed", label: "Confirmed" },
          { value: "played", label: "Playing" },
          { value: "finished", label: "Finish" },
          { value: "cancelled", label: "Cancelled" },
        ].map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>
      {formError && <div className="text-danger mt-1">{formError}</div>}
    </div>
  );
};

export default ChangeOrderStatus;
